import { Card, Descriptions, Space, Typography } from "antd";
import { formatCurrency, formatDate } from "./utils";
import PropTypes from 'prop-types';

export const InfoSection = ({ sinistre, montant, montantPaye, audioUrl }) => {
    return (
        <Card bordered={false} style={{ marginBottom: 16 }}>
            <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered size="small">
                <Descriptions.Item label="Numéro de Police">
                    {sinistre?.contrat?.numeroPoliceM || sinistre?.contrat?.numeroPoliceP || '-'}
                </Descriptions.Item>

                <Descriptions.Item label="Assuré">
                    {[sinistre?.contrat?.souscripteur?.prenom, sinistre?.contrat?.souscripteur?.nom]
                        .filter(Boolean)
                        .join(' ') || '-'}
                </Descriptions.Item>

                <Descriptions.Item label="Immatriculation">
                    {sinistre?.engin?.immatriculation || '-'}
                </Descriptions.Item>

                <Descriptions.Item label="Évaluation courante">
                    <Space direction="vertical" size={0}>
                        <Typography.Text strong>
                            {formatCurrency(sinistre?.evaluation)} FCFA
                        </Typography.Text>
                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                            Ouverture: {formatCurrency(sinistre?.evaluationOuverture)} FCFA
                        </Typography.Text>
                    </Space>
                </Descriptions.Item>

                <Descriptions.Item label="Sinistre À Payer">
                    <Typography.Text strong style={{ color: 'black' }}>
                        {formatCurrency(sinistre?.sap || 0)} FCFA
                    </Typography.Text>
                </Descriptions.Item>

                <Descriptions.Item label="Montant réglé">
                    <Typography.Text strong style={{ color: 'black' }}>
                        {formatCurrency(montant)} FCFA
                    </Typography.Text>
                </Descriptions.Item>

                <Descriptions.Item label="Montant Payé">
                    <Typography.Text strong style={{ color: '#389e0d' }}>
                        {formatCurrency(montantPaye || 0)} FCFA
                    </Typography.Text>
                </Descriptions.Item>

                <Descriptions.Item label="Date de survenance">
                    {formatDate(sinistre?.dateSinistre)}
                </Descriptions.Item>

                <Descriptions.Item label="Lieu">
                    {sinistre?.lieu || '-'}
                </Descriptions.Item>

                <Descriptions.Item label="Déclarant">
                    {[sinistre?.nomDeclarant, sinistre?.phoneDeclarant]
                        .filter(Boolean)
                        .join(' - ') || '-'}
                </Descriptions.Item>

                <Descriptions.Item label="Circonstances" span={3}>
                    {sinistre?.circonstance || '-'}
                </Descriptions.Item>

                {audioUrl && (
                    <Descriptions.Item label="Enregistrement Audio" span={3}>
                        <audio controls src={audioUrl} style={{ width: '100%', maxWidth: 500 }} />
                    </Descriptions.Item>
                )}
            </Descriptions>
        </Card>
    );
};

InfoSection.propTypes = {
    sinistre: PropTypes.object,
    montant: PropTypes.number,
    montantPaye: PropTypes.number,
    audioUrl: PropTypes.string
};